import React from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <>
      {/* Content Animation */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        style={{ width: '100%' }}
      >
        {children}
      </motion.div>

      {/* Exit Overlays - Expand from center */}
      <motion.div
        className="transition-overlay-exit-top"
        initial={{ scaleY: 0, opacity: 0, zIndex: -1, visibility: 'hidden', display: 'none' }}
        animate={{ scaleY: 0, opacity: 0, zIndex: -1, visibility: 'hidden', transitionEnd: { display: 'none' } }}
        exit={{ scaleY: 1, opacity: 1, zIndex: 99999, visibility: 'visible', display: 'block' }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '50vh',
          backgroundColor: 'var(--color-green, #77F76C)',
          transformOrigin: 'bottom',
          zIndex: 99999,
          pointerEvents: 'none',
        }}
      />
      <motion.div
        className="transition-overlay-exit-bottom"
        initial={{ scaleY: 0, opacity: 0, zIndex: -1, visibility: 'hidden', display: 'none' }}
        animate={{ scaleY: 0, opacity: 0, zIndex: -1, visibility: 'hidden', transitionEnd: { display: 'none' } }}
        exit={{ scaleY: 1, opacity: 1, zIndex: 99999, visibility: 'visible', display: 'block' }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50vh',
          backgroundColor: 'var(--color-green, #77F76C)',
          transformOrigin: 'top',
          zIndex: 99999,
          pointerEvents: 'none',
        }}
      />

      {/* Enter Overlays - Shrink to top/bottom */}
      <motion.div
        className="transition-overlay-enter-top"
        initial={{ scaleY: 1, zIndex: 99999, visibility: 'visible', display: 'block' }}
        animate={{ scaleY: 0, opacity: 0, transitionEnd: { display: "none", zIndex: -1, visibility: 'hidden', height: 0, width: 0 } }}
        exit={{ scaleY: 0, zIndex: -1, visibility: 'hidden', display: 'none' }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '50vh',
          backgroundColor: 'var(--color-green, #77F76C)',
          transformOrigin: 'top',
          zIndex: 99999,
          pointerEvents: 'none',
        }}
      />
      <motion.div
        className="transition-overlay-enter-bottom"
        initial={{ scaleY: 1, zIndex: 99999, visibility: 'visible', display: 'block' }}
        animate={{ scaleY: 0, opacity: 0, transitionEnd: { display: "none", zIndex: -1, visibility: 'hidden', height: 0, width: 0 } }}
        exit={{ scaleY: 0, zIndex: -1, visibility: 'hidden', display: 'none' }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50vh',
          backgroundColor: 'var(--color-green, #77F76C)',
          transformOrigin: 'bottom',
          zIndex: 99999,
          pointerEvents: 'none',
        }}
      />
    </>
  );
};

export default PageTransition;
